/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useImperativeHandle, forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUserApiToken, selectCurrentUserM11Use } from "../../slices/currentUser/currentUserSlice";
import { m11ReportContainerFoiChanged, m11ReportContainerResourceChanged, m11ReportSection10FoiChanged, m11ReportSection10ResourceChanged, m11ResearchStudyResourceChanged, selectM11ReportContainerFoi, selectM11ReportContainerResource, selectM11ReportSection10Foi, selectM11ReportSection10Resource, selectM11ResearchStudyResource } from "../../slices/m11ReportAuthoringTool/m11ReportAuthoringToolSlice";
import jsonEquals from "../../functions/jsonEquals";
import { StringKeyedEntry } from "../../datatypeComponents/StringEntry";
import ArrayEntry from "../../datatypeComponents/ArrayEntry";
import getIdFromReference from "../../functions/getIdFromReference";
import loadResource from "../m11ReportFunctions/loadResource";
import BooleanEntry from "../../datatypeComponents/BooleanEntry";
import TextDivEntry from "./TextDivEntry";
import { Button } from "semantic-ui-react";
import saveM11Changes from "../../functions/saveM11ChangesAPI";
import { selectM11ResearchStudyFoi } from "../../slices/m11StepCount/m11StepCountSlice";
import { validateStep } from "../../functions/validateM11ReportAPI";

const saveExploratoryObjectivesChanges = async (dispatch, apiToken, m11ResearchStudyFoi, exploratoryObjectivesState,
    objectiveDictionaryState, setAlertModalState,
    setStartingExploratoryObjectivesState, setStartingObjectiveDictionaryState) => {

    if (exploratoryObjectivesState.notApplicable === true) {
        if (exploratoryObjectivesState.objectivesArray.length > 0) {
            alert("This will delete exploratory objectives content.")
        }
    }
    let changesStates = {
        exploratoryObjectivesState: exploratoryObjectivesState,
        objectiveDictionaryState: objectiveDictionaryState
    };
    let response = await saveM11Changes(apiToken, 11, m11ResearchStudyFoi, changesStates);
    if (response?.success) {
        let revisedObjectivesState = JSON.parse(JSON.stringify(exploratoryObjectivesState));
        if (response.m11ResearchStudyResource) {
            dispatch(m11ResearchStudyResourceChanged(response.m11ResearchStudyResource));
            if (response.m11ResearchStudyResource.objective) {
                revisedObjectivesState.objectivesArray = response.m11ResearchStudyResource.objective;
                for (const objective of revisedObjectivesState.objectivesArray) {
                    if (objective?.type?.coding?.[0]?.code === "exploratory") {
                        revisedObjectivesState.exploratoryObjectivesArray.push(objective);
                    }
                }
            }
        }
        if (response.m11ReportContainerResource) {
            dispatch(m11ReportContainerResourceChanged(response.m11ReportContainerResource));
        }
        if (response.m11ReportSection10Resource) {
            dispatch(m11ReportSection10ResourceChanged(response.m11ReportSection10Resource));
        }
        setStartingObjectiveDictionaryState(JSON.parse(JSON.stringify(objectiveDictionaryState)));
        setStartingExploratoryObjectivesState(JSON.parse(JSON.stringify(revisedObjectivesState)));
    } else {
        if (response.error) {
            alert(response.error);
        }
    }
};

const M11Step011ExploratoryObjectives = forwardRef(({ theM11ResearchStudyFoi, setAlertModalState }, ref) => {

    const dispatch = useDispatch();
    const apiToken = useSelector(selectCurrentUserApiToken);
    const m11User = useSelector(selectCurrentUserM11Use);
    const m11ResearchStudyResource = useSelector(selectM11ResearchStudyResource);
    const m11ReportContainerFoi = useSelector(selectM11ReportContainerFoi);
    const m11ReportContainerResource = useSelector(selectM11ReportContainerResource);
    const m11ReportSection10Foi = useSelector(selectM11ReportSection10Foi);
    const m11ReportSection10Resource = useSelector(selectM11ReportSection10Resource);
    const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

    const [exploratoryObjectivesState, setExploratoryObjectivesState] = useState({
        "section106Heading": "",
        "section106Status": "empty", "section106Xhtml": "",
        "objectivesArray": [], "exploratoryObjectivesArray": [],
        "notApplicable": false
    });
    const [startingExploratoryObjectivesState, setStartingExploratoryObjectivesState] = useState({
        "section106Heading": "",
        "section106Status": "empty", "section106Xhtml": "",
        "objectivesArray": [], "exploratoryObjectivesArray": [],
        "notApplicable": false
    });
    const [initialCalculationNeeded, setInitialCalculationNeeded] = useState(false);
    const [expandObjectiveState, setExpandObjectiveState] = useState({});
    const [objectiveDictionaryState, setObjectiveDictionaryState] = useState({});
    const [startingObjectiveDictionaryState, setStartingObjectiveDictionaryState] = useState({});
    const [containedResourceDictionary, setContainedResourceDictionary] = useState({});

    useImperativeHandle(ref, () => ({
        unsavedChanges: (m11ResearchStudyResource &&
            (!jsonEquals(exploratoryObjectivesState, startingExploratoryObjectivesState) ||
                !jsonEquals(objectiveDictionaryState, startingObjectiveDictionaryState))),
        async saveAllChanges() {
            await saveExploratoryObjectivesChanges(dispatch, apiToken, m11ResearchStudyFoi, exploratoryObjectivesState,
                objectiveDictionaryState, setAlertModalState,
                setStartingExploratoryObjectivesState, setStartingObjectiveDictionaryState);
        }
    }));

    useEffect(() => {
        if (m11ResearchStudyResource?.id) {
            let m11ReportFoi = "";
            if (m11ResearchStudyResource.relatesTo?.length > 0) {
                for (let relatesTo of m11ResearchStudyResource.relatesTo) {
                    if (relatesTo.type?.coding?.[0]?.code === "supported-with" && relatesTo.type.text === "M11 Report" &&
                        relatesTo.targetReference) {
                        m11ReportFoi = getIdFromReference(relatesTo.targetReference);
                    }
                }
            }
            if (m11ReportFoi && !isNaN(m11ReportFoi) && m11ReportFoi !== m11ReportContainerFoi) {
                dispatch(m11ReportContainerFoiChanged(m11ReportFoi));
            } else {
                setInitialCalculationNeeded(true);
            }
            if (Array.isArray(m11ResearchStudyResource.contained) && m11ResearchStudyResource.contained.length > 0) {
                let containedResourceDictionary = {};
                for (const item of m11ResearchStudyResource.contained) {
                    const key = "#" + item.id;
                    containedResourceDictionary[key] = item;
                }
                setContainedResourceDictionary(containedResourceDictionary);
            }
        }
    }, [m11ResearchStudyResource]);

    useEffect(() => {
        if (initialCalculationNeeded === true) {
            let startingData = {
                "section106Heading": "",
                "section106Status": "empty", "section106Xhtml": "",
                "objectivesArray": [], "exploratoryObjectivesArray": [],
                "notApplicable": false, "loaded": true
            };
            if (m11ResearchStudyResource.objective) {
                startingData.objectivesArray = JSON.parse(JSON.stringify(m11ResearchStudyResource.objective));
                for (const objective of startingData.objectivesArray) {
                    if (objective?.type?.coding?.[0]?.code === "exploratory") {
                        startingData.exploratoryObjectivesArray.push(JSON.parse(JSON.stringify(objective)));
                    }
                }
            }
            if (startingData.exploratoryObjectivesArray?.length > 0) {
                let startingSet = {};
                let startingDictionary = {};
                for (const index in startingData.exploratoryObjectivesArray) {
                    startingSet[index] = false;
                    startingDictionary[index] = startingData.exploratoryObjectivesArray[index];
                }
                setExpandObjectiveState(startingSet);
                setObjectiveDictionaryState(startingDictionary);
                setStartingObjectiveDictionaryState(JSON.parse(JSON.stringify(startingDictionary)));
            } else {
                let startingSet = { "0": true };
                let startingDictionary = {
                    "0": {
                        "name": "",
                        "description": "",
                        "outcomeMeasure": []
                    }
                };
                setExpandObjectiveState(startingSet);
                setObjectiveDictionaryState(startingDictionary);
                setStartingObjectiveDictionaryState(JSON.parse(JSON.stringify(startingDictionary)));
            }
            setExploratoryObjectivesState(startingData);
            setStartingExploratoryObjectivesState(startingData);
        }
    }, [initialCalculationNeeded]);

    useEffect(() => {
        if (m11ReportContainerFoi && !isNaN(m11ReportContainerFoi)) {
            loadResource(m11ReportContainerFoi, "M11ReportContainer", apiToken, dispatch);
        }
    }, [m11ReportContainerFoi]);

    useEffect(() => {
        if (m11ReportContainerResource && Object.keys(m11ReportContainerResource).length > 0) {
            if (m11ReportContainerResource.section?.[10]?.entry?.length) {
                let m11ReportSection010Foi = getIdFromReference(m11ReportContainerResource.section[10].entry[0]);
                if (m11ReportSection010Foi && !isNaN(m11ReportSection010Foi) && m11ReportSection010Foi !== m11ReportSection10Foi) {
                    dispatch(m11ReportSection10FoiChanged(m11ReportSection010Foi));
                } else {
                    setInitialCalculationNeeded(true);
                }
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ReportContainerResource]);

    useEffect(() => {
        if (m11ReportSection10Foi && !isNaN(m11ReportSection10Foi)) {
            loadResource(m11ReportSection10Foi, "M11ReportSection10", apiToken, dispatch);
        }
    }, [m11ReportSection10Foi]);

    useEffect(() => {
        if (m11ReportSection10Resource && Object.keys(m11ReportSection10Resource).length > 0) {
            let startingData = {
                "section106Heading": "",
                "section106Status": "empty", "section106Xhtml": "",
                "objectivesArray": [], "exploratoryObjectivesArray": [],
                "notApplicable": false, "loaded": true
            };
            if (m11ResearchStudyResource.objective) {
                startingData.objectivesArray = JSON.parse(JSON.stringify(m11ResearchStudyResource.objective));
                for (const objective of startingData.objectivesArray) {
                    if (objective?.type?.coding?.[0]?.code === "exploratory") {
                        startingData.exploratoryObjectivesArray.push(JSON.parse(JSON.stringify(objective)));
                    }
                }
            }
            if (m11ReportSection10Resource.section?.[0]?.section?.[5]?.title) {
                startingData.section106Heading = m11ReportSection10Resource.section[0].section[5].title;
            }
            if (m11ReportSection10Resource.section?.[0]?.section?.[5]?.text) {
                startingData.section106Status = m11ReportSection10Resource.section[0].section[5].text.status;
                startingData.section106Xhtml = m11ReportSection10Resource.section[0].section[5].text.div;
            }
            if (startingData.section106Status !== "empty" &&
                (startingData.section106Xhtml === "<div xmlns=\"http://www.w3.org/1999/xhtml\">Not applicable.</div>" ||
                    startingData.section106Xhtml === "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>Not applicable.</p></div>")
            ) {
                startingData.notApplicable = true;
                setExploratoryObjectivesState(startingData);
                setStartingExploratoryObjectivesState(startingData);
            } else if (startingData.exploratoryObjectivesArray?.length > 0) {
                let startingSet = {};
                let startingDictionary = {};
                for (const index in startingData.exploratoryObjectivesArray) {
                    startingSet[index] = false;
                    startingDictionary[index] = startingData.exploratoryObjectivesArray[index];
                }
                setExpandObjectiveState(startingSet);
                setObjectiveDictionaryState(startingDictionary);
                setStartingObjectiveDictionaryState(JSON.parse(JSON.stringify(startingDictionary)));
                setExploratoryObjectivesState(startingData);
                setStartingExploratoryObjectivesState(startingData);
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ReportSection10Resource]);

    return <div>
        <div className="h3Style h3EntryLabel" style={{ marginBottom: "0px" }}>
            Enter Exploratory Objectives.<span> This will be used in Sections 3 (Objectives and Estimands) and 10 (Statistical Considerations).</span>
        </div>
        {!(m11ReportSection10Resource?.id || m11ReportContainerResource?.id) &&
            <h1 style={{ color: "red" }}>Please complete Step 5 (Complete Title Page) before filling in M11 Report Section details.</h1>
        }
        {m11User === "sample" ?
            <div style={{ outline: "1px solid #000000", padding: "6px", width: "fit-content" }}>
                <h2>You are using the M11 Report Authoring Tool (Test Drive Version).</h2>
                <p style={{ color: "red" }}>Step 11 (Enter Exploratory Objectives) is not included in the M11 Report Authoring Tool (Test Drive Version).</p>
                <p>Subscribe to the M11 Report Authoring Tool (Professional Version) for complete functionality.</p>
            </div>
            :
            <>{
                exploratoryObjectivesState.loaded &&
                <>
                    <div className="h4Style h4EntryLabel" style={{ marginBottom: "0px" }}>
                        <span>Set as </span>Not Applicable<span> if there are no exploratory objectives.</span>
                    </div>
                    <BooleanEntry elementName='notApplicable'
                        fieldLabel='Not Applicable' startingValue={exploratoryObjectivesState.notApplicable}
                        setResourceState={setExploratoryObjectivesState} />
                    {exploratoryObjectivesState.notApplicable === false &&
                        <>
                            {
                                objectiveDictionaryState && Object.keys(objectiveDictionaryState).length > 0 &&
                                Object.keys(objectiveDictionaryState).map((key, index) => {
                                    let objective = objectiveDictionaryState[key];
                                    return <div key={index}>
                                        <h3>Exploratory Objective {index + 1} {objective.name}  <button onClick={() => {
                                            setExpandObjectiveState(prevState => { return { ...prevState, [index]: !expandObjectiveState[index] } });
                                        }}>{expandObjectiveState[index] ? " ▼ collapse  " : " ► expand  "}</button></h3>
                                        {expandObjectiveState[index] && <div>
                                            {objective && <>
                                                <div className="h4Style h4EntryLabel" style={{ marginBottom: "0px" }}>
                                                    <span>Enter a name or short label for Exploratory Objective {index + 1}.</span>
                                                </div>
                                                <StringKeyedEntry elementName='name'
                                                    required={true}
                                                    fieldLabel='Objective Name'
                                                    startingValue={objectiveDictionaryState[key].name}
                                                    index={index}
                                                    setKeyedResourceState={setObjectiveDictionaryState} />
                                                <div className="h4Style h4EntryLabel" style={{ marginBottom: "0px" }}>
                                                    <span>Enter a nontechnical (layperson) description for Exploratory Objective {index + 1}.</span>
                                                </div>
                                                <StringKeyedEntry elementName='description'
                                                    fieldLabel='Objective Description'
                                                    startingValue={objectiveDictionaryState[key].description}
                                                    index={index}
                                                    setKeyedResourceState={setObjectiveDictionaryState} />
                                                <div className="h4Style h4EntryLabel" style={{ marginBottom: "0px" }}>
                                                    <span>Complete the Estimand Characteristics detail for each outcome and estimand for this objective. Click the </span>+Add Estimand<span> button to enter data for additional estimands.</span>
                                                </div>
                                                {!jsonEquals(objectiveDictionaryState[index], {
                                                    "name": "",
                                                    "description": "",
                                                    "outcomeMeasure": []
                                                }) &&
                                                    <ArrayEntry datatype="M11Estimand" elementName='outcomeMeasure'
                containedResourceDictionary={containedResourceDictionary}
                                                        doNotShowFieldLabel={true}
                                                        startCollapsed={true} startEmptyArrayClosed={false}
                                                        deletable={true} fieldLabel='Estimand'
                                                        startingValue={objectiveDictionaryState[key].outcomeMeasure || []}
                                                        index={index}
                                                        setKeyedResourceState={setObjectiveDictionaryState} />
                                                }
                                            </>}
                                        </div>}
                                    </div>
                                })
                            }
                            <div style={{ marginBottom: "12px" }}>
                                {(objectiveDictionaryState && exploratoryObjectivesState.exploratoryObjectivesArray) &&
                                    <>
                                        <Button className="formButton" style={{ color: "#000000" }}
                                            content={"+ Add Exploratory Objective"}
                                            onClick={() => {
                                                let newIndex = exploratoryObjectivesState.exploratoryObjectivesArray.length || 1;
                                                setExpandObjectiveState(prevState => { return { ...prevState, [newIndex]: true } });
                                                setObjectiveDictionaryState(prevState => {
                                                    return {
                                                        ...prevState,
                                                        [newIndex]: {
                                                            "name": "",
                                                            "description": "",
                                                            "outcomeMeasure": []
                                                        }
                                                    };
                                                });
                                            }} />
                                    </>}
                            </div>
                            <div className="h3Style h3EntryLabel" style={{ marginBottom: "0px" }}>
                                Complete Section 10.6 Analyses Associated with the Exploratory Objective(s).
                            </div>
                            <TextDivEntry elementName="section106Xhtml"
                                startingValue={exploratoryObjectivesState.section106Xhtml}
                                setResourceState={setExploratoryObjectivesState} />
                        </>
                    }
                </>
            }</>
        }
    </div>
});

const M11Step011ExploratoryObjectivesHelperText = <div>
    <h3>Enter Exploratory Objectives</h3>
    <div style={{ textAlign: "left" }}>
        <p>Set as Not Applicable if there are no exploratory objectives.</p>
        <p>Enter detail to add an exploratory objective, or proceed to Step 12 if there are no additional objectives to add.</p>
        <div style={{ marginLeft: "24px" }}>
            <p>Enter a name or short label for the Exploratory Objective. This will be used in the M11 Report Section 3.3 Exploratory Objective(s).</p>
            <p>Enter a nontechnical (layperson) description for the Exploratory Objective.</p>
            <p>Complete the Estimand Characteristics detail for each outcome and estimand for this objective. Click the +Add Estimand button to enter data for additional estimands.</p>
        </div>
        <p>Enter Section 10.6 Analyses Associated with the Exploratory Objective(s)</p>
        <div style={{ marginLeft: "24px" }}>
            <p>Describe any exploratory analyses, if applicable. Additional subsections may be created to describe the analyses for each exploratory objective, as needed.</p>
        </div>
        <p>Click the 'Save All Changes' button.</p>
    </div>
</div>

// eslint-disable-next-line no-empty-pattern
const M11Step011ExploratoryObjectivesValidationCheck = ({ }) => {

    const apiToken = useSelector(selectCurrentUserApiToken);
    const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

    const [validationCheckState, setValidationCheckState] = useState({});

    useEffect(() => {
        if (m11ResearchStudyFoi) {
            validateStep(apiToken, 11, m11ResearchStudyFoi,
                setValidationCheckState)
        }
    }, [m11ResearchStudyFoi]);

    return <div>{validationCheckState?.success && <div>
        <h4>Step 11 (Enter Additional Objectives) {validationCheckState.step11numberOfChecks} issues checked. {validationCheckState.step11numberPassed} passed. {validationCheckState.step11numberFailed} failed.</h4>
        <p>All exploratory objectives have at least one associated estimand: {validationCheckState.resultCheckExploratoryObjectiveHasEstimand}</p>
        <p>Each estimand has an Endpoint description: {validationCheckState.resultCheckExploratoryEstimandHasEndpoint}</p>
        <p>Section 10.6 heading is 'Analyses Associated with the Exploratory Objective(s)': {validationCheckState.resultCheckSection106Heading}</p>
        <p>Section 10.6 Analyses Associated with the Exploratory Objective(s) has content: {validationCheckState.resultCheckSection106Content}</p>
    </div>}  </div>
}

export default M11Step011ExploratoryObjectives;
export { M11Step011ExploratoryObjectivesHelperText, M11Step011ExploratoryObjectivesValidationCheck };